<div class="viewer bpmn-viewer-background">
    <button style="display:none;width: 100px" (click)="exportXMl()">print xml</button>
    <gen-overlay-loader class="loader" *ngIf="spinnerActive|async" [showOverlay]="true"></gen-overlay-loader>
    <notification-container *ngIf="useSideBarComponent" [position]="'banner-local'" [ngClass]="globalNotificationClass" key="single-line"></notification-container>
    <div id="js-canvas" class="canvas" [ngClass]="{'hide-bpmn-logo':hideBpmnLogo}"></div>
    <gen-panel *ngIf="!useSideBarComponent" class="node-creator-panel" [name]="panelName" [position]="panelPosition" [panelId]="'rightPanel'"
               (toggleDisplayStatusChanged)="toggleOpenPanel($event)"
               [fullHeight]="true"></gen-panel>
   <section *ngIf="useSideBarComponent">
     <div class="right-sidebar-expander-wrapper" [ngClass]="{'none': showSidebar}" >
      <span class="right-sidebar-expander pointer icon__dls-navigation-left-x-bold-32" dlsToggleButton name="toggle" ngDefaultControl [(ngModel)]="singleOn"
            (click)="toggleSideBar(!showSidebar)"></span>
      <span class="right-sidebar-expander defaultCursor vertical">{{sideBarExpanderTitle}}</span>
    </div>

    <dls-sidebar class="right-sidebar" [visible]="showSidebar" [sidebarWidth]="37" sideBarPosition="right" [showCloseIcon]="false" [sideModal]="false">
      <gen-panel class="node-creator-panel"
                 [displayStatus]="true"
                 [name]="panelName"
                 [position]="panelPosition"
                 [showCloseSideBarIcon]="true"
                 (onToggleSidePanelBar) = toggleSideBar($event)
                 (onSetSidePanelBarTitle) = setSideBarExpanderTitle($event)
                 [fullHeight]="true">
      </gen-panel>
    </dls-sidebar>
  </section>
</div>
